import { QueryResult, useQuery } from '@apollo/client';
import { LocalCache } from 'apollo-client/queries/LocalCache';
import { LOCAL_FILTERS } from 'apollo-client/queries/LOCAL_FILTERS';

export const useLocalCache = (): QueryResult<LocalCache, LocalCache> => {
  const localFilters = useQuery<LocalCache, LocalCache>(LOCAL_FILTERS, { fetchPolicy: 'cache-only' });
  return localFilters;
};
